<script lang="ts">
    import { apiBaseURL } from "../../../config"

    export let image: Media
</script>

<img
    src="{`${apiBaseURL}media/${image.id}/${image.file.src}`}"
    alt="Image Preview"
    class="image"
    aria-hidden="true"
/>

<style lang="less">
    .image {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 4px;
    }
</style>
